<template>
  <div class="block-form">
    <q-input
      outlined
      :model-value="block.title"
      label="Título"
      @update:model-value="emit('update', { ...block, title: String($event ?? '') })"
    />
    <q-input
      outlined
      type="textarea"
      :model-value="block.content"
      label="Contenido"
      rows="3"
      @update:model-value="emit('update', { ...block, content: String($event ?? '') })"
    />
  </div>
</template>

<script setup lang="ts">
interface ToggleBlock {
  type: 'toggle';
  title: string;
  content: string;
}

const props = defineProps<{ block: ToggleBlock }>();
const emit = defineEmits<{ (e: 'update', block: ToggleBlock): void }>();

void props;
</script>

<style scoped lang="scss">
.block-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}
</style>
